import { useTranslation } from "react-i18next";

function Tornei() {
  const { t } = useTranslation();

  return (
    <section id="tornei" className="tornei-section">
      <div>
        <div className="tornei-header">
          <h2 className="base-title">Tornei</h2>
          {/* <p className="base-subtitle">
            Scriviamo quanto siamo bravi, quanti tornei facciamo e a quanti
            circuiti partecipiamo
          </p> */}
        </div>

        <div className="base-text-container">
          {t("tornei.texts", { returnObjects: true }).map((text, index) => (
            <div key={index}>
              <p className="base-subtitle mb-4">{text.subtitle}</p>
              {/* <p className="">{text.text}</p> */}
              {text.text.map((paragraph, paragraphIndex) => (
                <p key={paragraphIndex} className="mb-4">
                  {paragraph}
                </p>
              ))}
            </div>
          ))}
        </div>

        {/* <div className="tornei-grid-3">
          <div className="base-subtitle">CSEN</div>
          <div className="base-subtitle">ASC</div>
          <div className="base-subtitle">Alpeadria</div>
        </div> */}
      </div>
    </section>
  );
}

export default Tornei;
